import { findDicsByCode } from '@/api/common/common';

const administor={
  state:{
    postCodeList:[],
    moralType:''
  },
  mutations: {
    setMoralType(state,data){
      state.postCodeList=data;
      state.moralType=data.code;
    }
  },
  actions:{
    getMoralType({dispatch,commit},codes){
      return new Promise((resolve,reject)=>{
        findDicsByCode(codes).then(res=>{
          const data=res.data.data;
          commit('setMoralType',data);
          resolve(res);
        }).catch(error=>{
					reject(error);
				})
      })
    }
  }
}

export default administor;


// WEBPACK FOOTER //
// ./src/store/modules/administor.js